import { cloneObject } from "../../common/domain/cloneObject";

export interface RichText {
  tokens: RichTextToken[];
}

export type RichTextToken = TextToken|BoldStartToken|BoldEndToken;

export interface TextToken {
  type: 'text';
  content: string;
};

export interface BoldStartToken {
  type: 'bold-start';
}

export interface BoldEndToken {
  type: 'bold-end';
}

export function parseRichText(text: string) : RichText {
  const tokens: RichTextToken[] = [];

  let tokenStartIndex = 0;

  let tagStartIndex: null|number = null;
  let tag: null|string = null;

  for (let i = 0; i < text.length; i++) {
    const char = text.charAt(i);

    if (char === '<') {
      tagStartIndex = i;
    }

    if (char === '>' && tagStartIndex !== null) {
      const tag = text.substring(tagStartIndex + 1, i);

      let token: RichTextToken | null = null;

      if (tag === 'b') {
        token = {
          type: 'bold-start'
        };
      } else if (tag === '/b') {
        token = {
          type: 'bold-end'
        };
      }

      if (token === null) {
        tagStartIndex = null;
        continue;
      }

      if (tokenStartIndex < tagStartIndex) {
        tokens.push({
          type: 'text',
          content: text.substring(tokenStartIndex, tagStartIndex)
        });
      }

      tokens.push(token);

      tagStartIndex = null;
      tokenStartIndex = i + 1;
    }
  }

  if (tokenStartIndex < text.length) {
    tokens.push({
      type: 'text',
      content: text.substring(tokenStartIndex)
    });
  }

  return { tokens };
}

